export const URL_API = 'https://protected-temple-37837.herokuapp.com';
export const URL_API_WS = 'wss://protected-temple-37837.herokuapp.com';

